import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../../assets/images/Souvenir/live.png";
import axios from "axios";
import AuctionNav from "./AuctionNav/AuctionNav";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import ProductCard from "./Content/ProductCard";

const SoldProductList = () => {
  const [soldProduct, setSoldProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/sold/auction/product`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setSoldProduct(res.data.sold_product);
      }
    });
  }, []);

  return (
    <>
      {/*   to={`/superstar-admin/product/details/${product.id}`} */}
      <AuctionNav />

      <div className="d-flex mb-4  head-line p-3">
        <div className=" d-flex">
          <img src={LiveIcon} className=" SouvenirIcon" alt="" />
        </div>
        <div className=" d-flex text-light fw-bold mt-1 mx-3 ">
          Sold Product
        </div>
      </div>

      {loading ? (
        <LoaderPost />
      ) : (
        <ProductCard data={soldProduct} noBidder="true" unsold="true" showOrderstatus={true}/>
      )}
    </>
  );
};

export default SoldProductList;
